import React from 'react';

import "./Loader.scss";

export default function Loader(props) {

  let className = 'loader';

  if (props.align) {
    className += ' loader--align-' + props.align;
  }

  return (
    <div className={className}>

        <div className="sk-chase">
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
        </div>

    </div>
  )

}
